import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface BaoCaoSLTK {
  name: string;
  api_token: string;
}

export interface BaoCaoSLTKDetaiInfor {
  errors: unknown;
  BaoCaoSLTK: BaoCaoSLTK;
  isAuthenticated: boolean;
}

@Module
export default class BaoCaoSLTKDetail
  extends VuexModule
  implements BaoCaoSLTKDetaiInfor
{
  errors = {};
  BaoCaoSLTK = {} as BaoCaoSLTK;
  isAuthenticated = !!JwtService.getToken();

  /**
   * Get current user object
   * @returns User
   */
  get BaoCaoSLTKDetail() {
    return this.baoCaoSLTKDetailData;
  }

  /**
   * Verify user authentication
   * @returns boolean
   */

  @Mutation
  [Mutations.SET_ERROR](error) {
    this.errors = { ...error };
  }

  @Mutation
  [Mutations.BAO_CAO_SLTK_DETAIL_DATA](BaoCaoSLTK) {
    this.baoCaoSLTKDetailData = BaoCaoSLTK;
  }
  @Action
  [Actions.BAO_CAO_SLTK_DETAIL](payload) {
    return ApiService.getDataDetail("/baocao_sltk", payload, "detail", payload)
      .then(({ data }) => {
        this.context.commit(Mutations.BAO_CAO_SLTK_DETAIL_DATA, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
      });
  }
}
